import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { updateProfileUseCase } from "../lib/update-profile.use-case";
import { getProfileUseCase } from "../lib/get-profile.use-case";
import { ProfileUpdateRequest } from "../model";
import { useMemberStore } from "../../auth/stores/member-store";

/**
 * 프로필 조회 hook
 */
export const useProfile = () => {
  const { user } = useMemberStore();

  return useQuery({
    queryKey: ["profile"],
    queryFn: async () => {
      return getProfileUseCase.execute();
    },
    enabled: !!user, // 사용자가 로그인한 경우에만 조회
    staleTime: 5 * 60 * 1000, // 5분간 캐시 유지
  });
};

/**
 * 프로필 업데이트 hook
 */
export const useUpdateProfile = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { user } = useMemberStore();

  return useMutation({
    mutationFn: async (data: ProfileUpdateRequest) => {
      if (!user?.id) {
        throw new Error("사용자 ID를 찾을 수 없습니다.");
      }
      return updateProfileUseCase.execute(user.id, data);
    },
    onSuccess: (data) => {
      console.log("Profile update successful", data);
    },
    onError: (error: Error) => {
      console.error("Profile update failed:", error.message);
      // 에러는 컴포넌트에서 처리
      throw error;
    },
  });
};
